import { VStack } from "@chakra-ui/react";
import { useSchoolsContext } from "../../../../Contexts/schoolContext";
import { Level, BehavioralSubject } from "../../../../services/Dtos";
import SubjectBar from "../SubjectSettings/SubjectBar";

interface Props {
  handleEditBehavioralSubject: (behavioralSubject: BehavioralSubject) => void;
  level: Level;
}

export default function BehavioralSubjectTable({
  handleEditBehavioralSubject,
  level,
}: Props) {
  const { behavioralSubjects } = useSchoolsContext();
  return (
    <VStack w="100%" align="stretch">
      {behavioralSubjects
        .filter((sub) => sub.levelId === level.id)
        .map((s) => (
          <SubjectBar
            key={s.id}
            behavioralSubject={s}
            handleEditBehavioralSubject={handleEditBehavioralSubject}
          />
        ))}
    </VStack>
  );
}
